/* eslint-disable react/prop-types */
import { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'

const PROFILE_TYPE_OPTIONS = [
  { value: 'TODOS', label: 'Todos os perfis (TODOS)' },
  { value: 'NEW_CLIENTS', label: 'Somente novos clientes (NEW_CLIENTS)' },
  { value: 'UPGRADE', label: 'Somente upgrade (UPGRADE)' },
]

function RemoveAutomaticDialog({ open, onClose, onConfirm, isPending }) {
  const [profileType, setProfileType] = useState('TODOS')

  function handleConfirm() {
    onConfirm(profileType === 'TODOS' ? undefined : [profileType])
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Remover cupons automáticos</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Selecione quais perfis de cupons automáticos devem ser removidos.
        </DialogContentText>
        <FormControl>
          <RadioGroup
            aria-label="Perfil dos cupons a remover"
            value={profileType}
            onChange={(event) => setProfileType(event.target.value)}
          >
            {PROFILE_TYPE_OPTIONS.map((option) => (
              <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={handleConfirm} disabled={isPending}>
          Remover
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveAutomaticDialog
